import {
  PUSH_NOTIFICATIONS_FETCH_SUCCESS,
  PUSH_NOTIFICATIONS_TOPICS_FETCH_SUCCESS
} from '../constant/actionType';

const initialState = {
  pushNotifications: [],
  pushNotificationsTopics: []
};

const pushNotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case PUSH_NOTIFICATIONS_FETCH_SUCCESS:
      return {
        ...state,
        pushNotifications: action.data
      };
    case PUSH_NOTIFICATIONS_TOPICS_FETCH_SUCCESS:
      return {
        ...state,
        pushNotificationsTopics: action.data
      };
    default:
      return state;
  }
};

export default pushNotificationReducer;
